import React from "react";
import styled from "styled-components";

import DomeHeader from "../components/DomeHeader";
import Breakpoints from "../components/styles/Breakpoints";
import { Colors } from "../components/styles/Colors";
import { Header3 } from "../components/typography";
import Video from "../components/Video";
import richText from "../utils/richText";

const Wrapper = styled.div`
  background: ${Colors.cream2};
  padding-bottom: 64px;

  > div:nth-child(2) {
    padding: 0 32px;
    margin-top: 48px;

    ${Header3} {
      color: ${Colors.grey};
    }

    > div:first-child {
      margin-bottom: 40px;
    }
  }

  @media ${Breakpoints.tablet} {
    display: flex;
    flex-direction: row-reverse;

    align-items: center;

    padding: 120px 0 120px 60px;

    > div:first-child {
      flex: 0 1 66%;

      max-width: 1000px;
    }

    > div:last-child {
      flex: 1 1 33%;
      margin-top: 0;
      margin-right: 80px;

      > * {
        max-width: 400px;
      }

      > div:first-child {
        display: inline-flex;
      }
    }
  }
`;

const BodyWrapper = styled.div`
  margin: 24px 0;

  p {
    color: ${Colors.greyLight};
  }

  h6 {
    margin: 24px 0 18px;
    color: ${Colors.grey};
  }

  h6 + p {
    margin: 0 0 32px;
  }

  p:last-child {
    font-size: 12px;
  }
`;

export default function ProductHowToUse({ product }) {
  return (
    <Wrapper>
      <Video url={product.howToUseVideo} />
      <div>
        <DomeHeader text="How To Use" centered />
        <Header3>{product.name}</Header3>
        <BodyWrapper>{richText(product.howToUse.raw)}</BodyWrapper>
      </div>
    </Wrapper>
  );
}
